import dayjs from 'dayjs';
import i18n from '@/plugins/i18n';
import { isEnLang } from '@/utils/api';

/**
 * 获取短日期格式模板（仅 MM-DD 类，不含 YYYY）
 * 中文：MM-DD → 03-04，英文：MMM-DD → Mar 04
 * @returns {string} dayjs format 字符串
 */
export function getShortDateOversea() {
  return isEnLang() ? 'MMM DD' : 'MM-DD';
}
export function format() {
  Date.prototype.format = function format(val) {
    if (typeof val !== 'string') {
      return '';
    }
    const time = this;
    const years = time.getFullYear();
    const month = ('0' + (time.getMonth() + 1)).substr(-2);
    const day = `0${time.getDate()}`.substr(-2);
    const hours = `0${time.getHours()}`.substr(-2);
    const minutes = `0${time.getMinutes()}`.substr(-2);
    const seconds = `0${time.getSeconds()}`.substr(-2);
    return val
      .replace(/YYYY/g, years)
      .replace(/MM/g, month)
      .replace(/DD/g, day)
      .replace(/HH/g, hours)
      .replace(/mm/g, minutes)
      .replace(/ss/g, seconds);
  };
}

export function isToday(timestamp, format = 'YYYY/MM/DD') {
  return dayjs(timestamp).format(format) === dayjs(Date.now()).format(format);
}

export function isTomorrow(timestamp) {
  return dayjs(timestamp).format('YYYY/MM/DD') === dayjs(Date.now() + 24 * 3600 * 1000).format('YYYY/MM/DD');
}

export function isYesterday(timestamp) {
  return dayjs(timestamp).format('YYYY/MM/DD') === dayjs(Date.now() - 24 * 3600 * 1000).format('YYYY/MM/DD');
}

export function isCurrentYear(timestamp) {
  return dayjs(timestamp).isSame(dayjs(), 'year');
}

/**
 * 获取指定日期当天 00:00:00 的时间戳
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * @returns {number}
 */
export function getStartOfDay(timestamp) {
  return dayjs(timestamp).startOf('day').valueOf();
}

/**
 * 获取指定日期当天 23:59:59.999 的时间戳
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * @returns {number}
 */
export function getEndOfDay(timestamp) {
  return dayjs(timestamp).endOf('day').valueOf();
}

/**
 * 时间格式化
 * @param date = 目标日期（时间戳）
 * @param fmt = 显示的格式
 * @returns {*}
 */
export const dateFormat = (date, fmt) => {
  const o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours() % 24 == 0 ? '00' : date.getHours() % 24,
    'H+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  const week = {
    0: '/u65e5',
    1: '/u4e00',
    2: '/u4e8c',
    3: '/u4e09',
    4: '/u56db',
    5: '/u4e94',
    6: '/u516d'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[date.getDay() + '']
    );
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/** 时间显示 今日 明日 今年   往年  **/
export const dateFormaCustom = (date) => {
  const data = dateFormat(new Date(Number(date)), 'yyyy-MM-dd HH:mm:ss');
  const Newdate = new Date();
  date = data.toString();
  const year = date.substring(0, 4);
  const month = date.substring(5, 7);
  const day = date.substring(8, 10);
  const hour = date.substring(11, 13);
  const minute = date.substring(14, 16);
  const createTime = year + '-' + month + '-' + day;

  const date0 = GetDateStr(0); //今天
  const str0 = date0.split('-');
  str0[1] = str0[1].length == 1 ? '0' + str0[1] : str0[1];
  str0[2] = str0[2].length == 1 ? '0' + str0[2] : str0[2];

  const date1 = GetDateStr(1); //明天
  const str1 = date1.split('-');
  str1[1] = str1[1].length == 1 ? '0' + str1[1] : str1[1];
  str1[2] = str1[2].length == 1 ? '0' + str1[2] : str1[2];

  const date2 = GetDateStr(-1); //昨天
  const str2 = date2.split('-');
  str2[1] = str2[1].length == 1 ? '0' + str2[1] : str2[1];
  str2[2] = str2[2].length == 1 ? '0' + str2[2] : str2[2];

  const date3 = Newdate.getFullYear(); //获取年份

  if (year == str0[0] && month == str0[1] && day == str0[2]) {
    return i18n.global.t('common.filter.today') + ' ' + hour + ':' + minute;
  } else if (year == str1[0] && month == str1[1] && day == str1[2]) {
    return i18n.global.t('common.filter.tomorrow') + ' ' + hour + ':' + minute;
  } else if (year == str2[0] && month == str2[1] && day == str2[2]) {
    return i18n.global.t('common.filter.yesterday') + ' ' + hour + ':' + minute;
  } else if (year == date3) {
    return month + '-' + day + ' ' + hour + ':' + minute;
  } else {
    return createTime;
  }

  function GetDateStr(AddDayCount) {
    const dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
    const y = dd.getFullYear();
    const m = dd.getMonth() + 1; //获取当前月份的日期
    const d = dd.getDate();
    return y + '-' + m + '-' + d;
  }
};

// 将秒数格式化为分秒29′30″
export const formatDuration = (seconds) => {
  return `${Math.floor(seconds / 60)}′${(seconds % 60).toString().padStart(2, '0')}″`;
};

/**
 * 归一化时间戳入参：纯数字字符串按毫秒时间戳处理，普通日期字符串保持原样。
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * @returns {number|string|Date}
 */
export const normalizeTimestamp = (timestamp) => {
  if (typeof timestamp === 'string') {
    const trimmedTimestamp = timestamp.trim();
    // 判断是否为纯数字字符串，用于识别后端返回的毫秒时间戳。
    const isNumericTimestamp = /^\d+$/.test(trimmedTimestamp);
    if (trimmedTimestamp && isNumericTimestamp) {
      return Number(trimmedTimestamp);
    }
  }
  return timestamp;
};

/**
 * 内部：相对日期时间片段（日期部分 + 时分），供 formatUpdateTime / formatRelativeDateTime 复用
 * @param {number|string|Date} timestamp
 * @param {{ includeYesterday?: boolean, hideZeroTime?: boolean }} options
 * @returns {{ datePart: string, timeStr: string, showTime: boolean }}
 */
function getRelativeDateTimeParts(timestamp, { includeYesterday = true, hideZeroTime = false } = {}) {
  const t = dayjs(timestamp);
  const timeStr = t.format('HH:mm');
  const isZeroTime = timeStr === '00:00';
  const showTime = !(hideZeroTime && isZeroTime);

  let datePart;
  if (includeYesterday && isYesterday(timestamp)) {
    datePart = i18n.global.t('common.filter.yesterday');
  } else if (isToday(timestamp)) {
    datePart = i18n.global.t('common.filter.today');
  } else if (isCurrentYear(timestamp)) {
    const shortDate = getShortDateOversea();
    datePart = t.format(shortDate);
  } else {
    datePart = t.format('YYYY-MM-DD');
  }
  return { datePart, timeStr, showTime };
}

/**
 * 格式化时间，让今天的时间带上【今天】前缀，其他时间有特殊处理
 * @param {*} timestamp 时间戳
 * @param {boolean} hideZeroTime 是否隐藏 00:00 时分，默认 false
 * @param {boolean} includeYesterday 是否包含昨天，默认 false
 * 昨天：昨天 HH:mm
 * 今天：今天 HH:mm
 * 今年：MM-DD HH:mm
 * 其他：YYYY-MM-DD HH:mm
 * @returns {string}
 */
export const formatUpdateTime = (timestamp, hideZeroTime = false, includeYesterday = false) => {
  if (!timestamp) return '-';
  const { datePart, timeStr, showTime } = getRelativeDateTimeParts(timestamp, {
    includeYesterday,
    hideZeroTime
  });
  return showTime ? `${datePart} ${timeStr}` : datePart;
};

/**
 * 今天 / 明天：展示「今天」「明天」文案；若为 00:00 则不拼接时分，否则拼接 HH:mm。
 * 其它日期：与单独调用 formatUpdateTime(timestamp) 一致（含昨天/今年/往年的相对展示与完整时分）。
 * @param {number|string|Date} timestamp
 * @returns {string}
 */
export function formatTodayTomorrowTime(timestamp) {
  if (!timestamp) return '-';
  const t = dayjs(timestamp);
  const hm = t.format('HH:mm');
  const timeSuffix = hm === '00:00' ? '' : ` ${hm}`;

  if (isToday(timestamp)) {
    return i18n.global.t('common.filter.today') + timeSuffix;
  }
  if (isTomorrow(timestamp)) {
    return i18n.global.t('common.filter.tomorrow') + timeSuffix;
  }
  return formatUpdateTime(t.valueOf());
}

/**
 * 相对日期（仅日期，无时分）：昨天/今天/今年/其他
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * 昨天:昨天
 * 今天:今天
 * 今年:MM-DD
 * 其他:YYYY-MM-DD
 * @returns {string}
 */
export const formatRelativeDate = (timestamp) => {
  if (!timestamp) return '-';
  if (isYesterday(timestamp)) return i18n.global.t('common.filter.yesterday');
  if (isToday(timestamp)) return i18n.global.t('common.filter.today');
  if (isCurrentYear(timestamp)) {
    const shortDate = getShortDateOversea();
    return dayjs(timestamp).format(shortDate);
  }
  return dayjs(timestamp).format('YYYY-MM-DD');
};

/**
 * 相对日期时间（带时分）：昨天/今天/今年/其他 + HH:mm
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * 昨天: 昨天 HH:mm
 * 今天: 今天 HH:mm
 * 今年: MM-DD HH:mm
 * 其他: YYYY-MM-DD HH:mm
 * @returns {string}
 */
export const formatRelativeDateTime = (timestamp) => {
  if (!timestamp) return '-';
  const normalizedTimestamp = normalizeTimestamp(timestamp);
  const { datePart, timeStr } = getRelativeDateTimeParts(normalizedTimestamp, { includeYesterday: true });
  return `${datePart} ${timeStr}`;
};

/**
 * 内容最近修改时间展示（研究模式工具栏等产品 V1.2 规范，与 formatUpdateTime / formatRelativeDateTime 不同）：
 * - 今天：仅 HH:mm（无「今天」前缀）
 * - 昨天：昨天 + HH:mm（无空格）
 * - 今年：M月D日（无时分）
 * - 往年：YYYY年M月D日（无时分）
 * @param {number|string|Date|undefined|null} timestamp Unix 毫秒时间戳
 * @returns {string} 格式化后的时间片段；无效输入返回空串
 */
export function formatContentUpdatedAt(timestamp) {
  if (timestamp === undefined || timestamp === null || timestamp === '') return '';
  const t = dayjs(Number(timestamp));
  if (!t.isValid()) return '';

  // 今天只展示时分，省略日期前缀
  if (isToday(timestamp)) {
    return t.format('HH:mm');
  }
  // 昨天拼接 i18n 文案与时分，产品规范无空格
  if (isYesterday(timestamp)) {
    return `${i18n.global.t('common.filter.yesterday')}${t.format('HH:mm')}`;
  }
  // 今年仅展示月日
  if (isCurrentYear(timestamp)) {
    return `${t.month() + 1}月${t.date()}日`;
  }
  return `${t.year()}年${t.month() + 1}月${t.date()}日`;
}

/**
 * 相对日期 + 星期：今年短日期+ddd，非今年 YYYY-MM-DD ddd
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * 今年: MM-DD ddd
 * 其他: YYYY-MM-DD ddd
 * @returns {string}
 */
export const formatRelativeDateWithWeekday = (timestamp) => {
  if (!timestamp) return '-';
  if (isCurrentYear(timestamp)) {
    const shortDate = getShortDateOversea();
    return dayjs(timestamp).format(shortDate + ' ddd');
  }
  return dayjs(timestamp).format('YYYY-MM-DD ddd');
};

/**
 * 自定义格式时间：按指定格式格式化日期
 * @param {number|string|Date} timestamp 时间戳或 dayjs 可解析值
 * @param {string} format 格式字符串，默认 'YYYY/MM/DD'
 * @returns {string}
 */
export const formatCustomTime = (timestamp, format = 'YYYY/MM/DD') => {
  if (!timestamp) return '-';
  if (format === 'MM-DD') {
    const shortDate = getShortDateOversea();
    return dayjs(timestamp).format(shortDate);
  }
  return dayjs(timestamp).format(format);
};

/**
 * 格式化发布日期
 * @param {number|string|Date} releaseDate - 发布日期
 * @returns {string} - 格式化后的日期字符串
 * @example
 *  "2025-07-14"
 *  "今天"
 *  "今天 14:30"
 */
export function formatReleaseDate(releaseDate) {
  if (dayjs(releaseDate).format('YYYY-MM-DD') === dayjs(new Date()).format('YYYY-MM-DD')) {
    if (dayjs(releaseDate).format('HH:mm') === '00:00') {
      return i18n.global.t('common.filter.today');
    } else {
      return i18n.global.t('common.filter.today') + ' ' + dayjs(releaseDate).format('HH:mm');
    }
  } else {
    return dayjs(releaseDate).format('YYYY-MM-DD');
  }
}

// 快捷时间 根据关键字返回时间
export const defaultShortcutsTime = (key) => {
  const today = dayjs();
  const weekDayFix = today.startOf('w').format('d') == 0 ? 1 : 0;

  function getTime(count) {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * count);
    return [start, end];
  }

  const defaultShortcuts = [
    {
      text: '近7天',
      value: () => {
        return getTime(7);
      }
    },
    {
      text: '近30天',
      value: () => {
        return getTime(30);
      }
    },
    {
      text: '近90天',
      value: () => {
        return getTime(90);
      }
    },
    {
      text: '近一年',
      value: () => {
        return getTime(365);
      }
    },
    {
      text: '明天',
      value: () => {
        return [today.add(1, 'd').startOf('d').valueOf(), today.add(1, 'd').endOf('d').valueOf()];
      }
    },
    {
      text: '本周',
      value: () => {
        return [today.startOf('w').add(weekDayFix, 'd').valueOf(), today.endOf('w').add(weekDayFix, 'd').valueOf()];
      }
    },
    {
      text: '下周',
      value: () => {
        return [
          today.add(1, 'w').startOf('w').add(weekDayFix, 'd').valueOf(),
          today.add(1, 'w').endOf('w').add(weekDayFix, 'd').valueOf()
        ];
      }
    },
    {
      text: '下下周',
      value: () => {
        return [
          today.add(2, 'w').startOf('w').add(weekDayFix, 'd').valueOf(),
          today.add(2, 'w').endOf('w').add(weekDayFix, 'd').valueOf()
        ];
      }
    }
  ];

  const shortcutsTime = defaultShortcuts.find((i) => i.text === key)?.value();
  return {
    startTime: shortcutsTime ? shortcutsTime[0] : '',
    endTime: shortcutsTime ? shortcutsTime[1] : ''
  };
};

/**
 * 将 UTC 时间格式化为本地时间
 * @param {number|string|Date} utcTime 时间戳或 dayjs 可解析值
 * @param {string} format 格式字符串，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string}
 */
export const formatUtcToLocal = (utcTime, format = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs.utc(utcTime).local().format(format);
};
